import * as AccountsReducerModule from 'app/redux/Accounts/reducer'
import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import * as NavReducerModule from 'app/redux/Nav/reducer'
import * as ProfileReducerModule from 'app/redux/Profile/reducer'
import * as SSAReducerModule from 'app/redux/ssa/reducer'
import * as UserReducerModule from 'app/redux/User/reducer'
import ImmutableMap from 'app/utils/immutable/map'
import * as Redux from 'redux'

/**
 * This files combines all reducers which creates the app's state
 *
 * To add a new reducer:
 * 1. Add reducer's interface state to IAppState
 * 2. Add reducer method to allReducers
 */
interface IAppState {
  readonly Accounts: ImmutableMap<AccountsReducerModule.IAccountsState>,
  readonly User: ImmutableMap<UserReducerModule.IUserState>,
  readonly Nav: ImmutableMap<NavReducerModule.INavState>,
  readonly Profile: ImmutableMap<ProfileReducerModule.IProfileState>
  readonly SSA: ImmutableMap<SSAReducerModule.ISSAOpState>
}

interface IAppAction extends IReducerAction {
  type: string
}

const allReducers = Redux.combineReducers<IAppState>({
  Accounts: AccountsReducerModule.functionalReducer.getReducerFunction(),
  User: UserReducerModule.functionalReducer.getReducerFunction(),
  Nav: NavReducerModule.functionalReducer.getReducerFunction(),
  Profile: ProfileReducerModule.ProfileReducer.getReducerFunction(),
  SSA: SSAReducerModule.functionalReducer.getReducerFunction()
})

const ActionTypes = {}

const AppReducer = new FunctionalReducer<IAppState>()
  .setDefaultReducer((state, action) => {
    return allReducers(state, action)
  })

export default AppReducer //for hot-reload
export {
  AppReducer,
  IAppState,
  ActionTypes,
  IAppAction
}



// WEBPACK FOOTER //
// ./src/app/redux/App/reducer/index.ts